export default __webpack_public_path__ + "static/media/Morph Crocodile Pict Chieftain.94604f85.jpg";